import { Box, Link, ListItemButton, styled } from '@mui/material';

import { css } from '/helpers/customCSS';
import { getOppositeColor } from '/helpers';
import { arrowRotation, getStyledOptions, styledCustom } from '/styles';

const baseSelect = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const CustomSelect = styledCustom(Box)<{ $isOpen: boolean; $width: number }>`
  ${baseSelect};
  border: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  position: relative;
  width: ${({ $width }) => (typeof $width === 'number' ? `${$width}px` : $width)};
  & svg {
    ${arrowRotation}
  }

  &:hover {
    border-bottom: 1px solid rgba(0, 0, 0, 0.87);
  }
  &:hover:disabled {
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  }

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    border-bottom: 2px solid #1976d2;
    transform: ${({ $isOpen }) => ($isOpen ? 'scaleX(1)' : 'scaleX(0)')};
    transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  }

  &:focus-within::after {
    transform: scaleX(1);
  }
`;
export const VersionButton = styled('button', getStyledOptions<{ isOpen: boolean }>(['isOpen']))<{ isOpen: boolean }>`
  ${baseSelect};
  border: 0;
  background-color: ${({ theme }) => theme.palette.warning.main};
  color: ${({ theme }) => getOppositeColor(theme.palette.warning.main)};
  border-radius: 5px;
  padding: 4px 4px 4px 8px;
  &:hover {
    background-color: ${({ theme }) => theme.palette.warning.dark};
  }
  &:disabled {
    background-color: ${({ theme }) => theme.palette.action.disabledBackground};
  }
  & svg {
    font-size: 14px;
    vertical-align: bottom;
    ${arrowRotation}
  }
  .MuiTypography-root {
    font-size: 12px;
    font-weight: bold;
  }
`;
export const CustomLink = styled(Link, getStyledOptions<{ isOpen: boolean }>(['isOpen']))<{ isOpen: boolean }>`
  cursor: pointer;
`;
export const ActionsContainer = styled('div')`
  display: flex;
  justify-self: end;
  gap: 8px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease;
  .MuiListItemButton-root:hover & {
    opacity: 1;
    visibility: visible;
  }
`;
export const ListItemButtonStyled = styledCustom(ListItemButton)<{ $hasFullTextSpace: boolean }>`
  display: grid;
  grid-template-columns: ${(props) => (props.$hasFullTextSpace ? 'auto' : 'auto 1fr auto')};
  align-items: center;
  gap: 8px;
  padding-block: 0;
`;
